import { Text, useMantineTheme } from '@mantine/core';
import classes from './AfaDocumentacionLink.module.css';
import { IconLink } from '@tabler/icons-react';

export interface AfaDocumentacionLinkProps {
  title: string;
  url: string;
  onClick?: () => void;
}

const AfaDocumentacionLink = ({ title, url, onClick }: AfaDocumentacionLinkProps) => {
  const theme = useMantineTheme();

  return (
    <div
      className={classes.link}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if ((e.key === 'Enter' || e.key === ' ') && onClick) {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <IconLink size={22} stroke={1.5} color={theme.colors.blue[6]} />
      <Text size="sm" fw={500} ml="xs">
        {title}
      </Text>
    </div>
  );
};

export default AfaDocumentacionLink;
